import type { TowerDesign } from "@/game/towerSpec";
import type { Material } from "@/physics/model";
const A572_65: Material = { name: "A572 Gr65", E: 200e9, Fy: 448e6, rho: 7850 };
/** 18-sided Sabre monopole, Exposure A. Per-section ODs not extracted -> base ~60in/top ~20in ESTIMATED. Grade A572-65 assumed. */
export const design: TowerDesign = {
  id: "monopole-southwindsor-187ft",
  name: "Monopole (South Windsor 187 ft, Sabre)",
  description: "Real 187 ft 18-sided Sabre monopole, South Windsor CT (Exp A).",
  author: "reference: 02_engineering_drawings",
  spec: {
    type: "monopole",
    height: 57.0,
    stack: { faces: 12, panels: 18, baseRadius: 0.762, topRadius: 0.254,
      legSection: "legXXL", braceSection: "braceHeavy", legMaterial: A572_65, braceMaterial: A572_65, bracing: "X" },
    shell: { baseDiameter: 1.524, topDiameter: 0.508 },
    foundation: { soil: "dense-sand",
      base: { type: "pier", width: 3.0, diameter: 3.0, depth: 8.5, concrete: "c30" },
      connection: { kind: "anchorBolts", nBolts: 12, bolt: "b1_75", grade: "f1554_105", boltCircleDia: 1.2, embedment: 0.45, edgeDistance: 0.3, platePlanArea: 1.8, plateThickness: 0.05, plateGrade: "a36rod", fc: 30e6 } },
  },
};
